<template>
  <div class="banner-wrapper" :class="displayLayout" ref="bannerWrapper">
    <template v-if="listIsLoading && datas.length === 0">
      <div class="banner-item empty" v-for="(_, index) in 3" :key="index"></div
    ></template>
    <template v-else>
      <!-- type 类名用于曝光打点时取到正确类别的目标节点 -->
      <div
        :class="type"
        class="banner-item-container visible"
        v-for="(item, index) in datas"
        :key="item.id"
        :data-index="index"
        @click="goDetail(item, index)"
      >
        <div class="off-icon" v-if="item.discount">
          <span>{{ item.discount + '% ' }}</span>
          <span class="off">OFF</span>
        </div>
        <div class="banner-item">
          <img
            class="background-img"
            v-lazy="getGamePic(item)"
            :key="`${item.id}_${randStr}`"
          />
          <div class="bacnground-gradient" />
          <div class="game-info">
            <img class="icon" v-lazy="item.gameIcon" />
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
    </template>
    <!-- 以下空 banner 用于辅助自适应布局，数量为 5 是因为按照需求一行最多展示 5 个 -->
    <div
      class="banner-item-container invisible"
      v-for="(_, index) in 5"
      :key="`invisible-${index}`"
    >
      <div class="banner-item"></div>
    </div>
  </div>
</template>

<script>
  import bannerMixins from '@/mixins/home/banner'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Banner2',
    mixins: [bannerMixins],
    components: {},
    props: {
      listIsLoading: { type: Boolean, default: true },
      gameList: { type: Array, default: () => [] },
      type: {
        type: String,
        default: '',
        require: true,
      },
      activeIndex: {
        type: Number,
      },
    },
    data() {
      return {
        prevHoverImg: null,
        randStr: '',
      }
    },
    computed: {
      ...mapGetters(['displayLayout']),
      datas() {
        const arr = this.gameList || []
        return arr.map((item) => {
          const { url } = item
          return {
            ...item,
            jumpUrl: url,
          }
        })
      },
    },
    watch: {
      activeIndex() {
        // 默认的是展示第一个 Tab 的图片，其它 Tab 如果用了 v-lazy 但是刚开始不在可视区域就不会加载
        // 给图片一个随机值 ：key="随机值"，避免懒加载不加载
        this.randStr = Math.random().toString()
      },
    },
    mounted() {
      this.$nextTick(() => {
        const containerDom = this.$refs.bannerWrapper
        containerDom.addEventListener('mousemove', (e) => this.moveHandler(e))
      })
    },
    methods: {
      moveHandler(e) {
        const target = e.target

        if (
          target &&
          target?.className &&
          target.className.includes('background-img')
        ) {
          // 务必每次重新获取 banner-item 因为改变窗口大小的时候也会调整游戏模块宽高
          if (this.prevHoverImg != target && this.prevHoverImg !== null) {
            // 若当前 hover 的图片并不是上一张则令上一张图片归位
            this.prevHoverImg.style.translate = `0px 0px`
          }
          const { width, height } = document
            .querySelector('.banner-item')
            .getBoundingClientRect()
          const mouseX = e.offsetX
          const mouseY = e.offsetY
          let imgX = 0,
            imgY = 0
          const scale = 1.15 // 与 CSS 中设置的放大倍数一样
          const thresholdX = (width * (scale - 1)).toFixed(2)
          const thresholdY = (height * (scale - 1)).toFixed(2)
          if (
            !(
              mouseX < thresholdX ||
              mouseY < thresholdY ||
              mouseX > width - thresholdX ||
              mouseY > height - thresholdY
            )
          ) {
            // banner-item 的宽度、高度的一半，除数控制图像移动的幅度
            imgX = (mouseX - width / 2) / 15
            imgY = (mouseY - height / 2) / 15
          }
          target.style.translate = `${imgX}px ${imgY}px`
          this.prevHoverImg = target
        } else {
          target.style.translate = `0px 0px`
        }
      },
      getGamePic({ verticalPictureUrl, picture }) {
        let url = verticalPictureUrl || picture
        return url
      },
    },
  }
</script>

<style scoped lang="scss">
  .banner-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .banner-item-container {
      display: flex;
      justify-content: center;
      position: relative;
      &.invisible {
        .banner-item {
          width: 475px;
          height: 0;
          margin-bottom: 0;
        }
      }
    }
    .off-icon {
      z-index: 1;
      position: absolute;
      right: 45px;
      top: -10px;
      width: 127px;
      height: 117px;
      background: center/contain no-repeat
        url('~@/assets/images/home/banner/banner2/off-icon.png');
      box-sizing: border-box;
      text-align: center;
      font-size: 0;
      box-sizing: border-box;
      padding: 18px;

      span {
        font: 700 30px/36px 'Roboto';
        color: $white;
      }
    }
    .banner-item {
      position: relative;
      margin-bottom: 42px;
      width: 475px;
      height: 640px;
      background: rgb(43, 42, 49);
      border-radius: 48px;
      overflow: hidden;

      .background-img {
        width: 100%;
        height: 100%;
        border-radius: inherit;
        object-fit: cover;
      }

      .bacnground-gradient {
        position: absolute;
        left: 0;
        bottom: 0;
        background: linear-gradient(
          180deg,
          rgba(29, 29, 39, 0) 0%,
          rgba(29, 29, 39, 0.6) 100%
        );
        width: 475px;
        height: 180px;
        border-radius: inherit;
      }

      .game-info {
        position: absolute;
        left: 30px;
        bottom: 30px;
        display: flex;
        align-items: center;
        .icon {
          width: 72px;
          height: 72px;
          border-radius: 50%;
        }
        span {
          font: 600 36px/40px 'Roboto';
          color: $white;
          margin-left: 18px;
          display: inline-block;
          max-width: 325px;
          @include canWrap(2);
          word-break: keep-all;
          overflow-wrap: break-word;
        }
      }
    }
  }
</style>
<style scoped lang="scss">
  @import './pc_style.scss';
  @include styling($scale: 0.95);
  // 768px 以下一行展示三个 banner
  // 768px-1024px 一行展示四个 banner
  @media screen and (min-width: 768px) {
    @include styling($scale: 0.87);
  }
  @media screen and (min-width: 810px) {
    @include styling($scale: 0.92);
  }
  @media screen and (min-width: 950px) {
    @include styling($scale: 0.98);
  }
  // 1025px-1280px 一行展示五个
  @media screen and (min-width: 1024px) {
    @include styling($scale: 0.95);
  }
  @media screen and (min-width: 1160px) {
    @include styling($scale: 0.98);
  }
  // 1280px以上 一行展示五个
  @media screen and (min-width: 1280px) {
    @include styling($scale: 1);
  }
</style>
